import { WagmiAdapter } from '@reown/appkit-adapter-wagmi';
import {createAppKit} from '@reown/appkit/react';
import { http } from 'viem';
import { createConfig, type CreateConfigParameters, type Config } from 'wagmi';

import config from 'configs/app';
import currentChain from 'lib/web3/currentChain';

import colors from '../../theme/foundations/colors';
import {BODY_TYPEFACE} from '../../theme/foundations/typography';
import zIndices from '../../theme/foundations/zIndices';
const feature = config.features.blockchainInteraction;

const chains: CreateConfigParameters['chains'] = [ currentChain ];

const transports = {
  [currentChain.id]: http(config.chain.rpcUrl || `${ config.api.endpoint }/api/eth-rpc`),
};

const batch = { multicall: { wait: 100 } };

export const metadata = {
  name: `${ config.chain.name } explorer`,
  description: `${ config.chain.name } explorer`,
  url: config.app.baseUrl,
  icons: [ config.UI.navigation.icon.default ].filter(Boolean),
};

const WalletInitModule = (() => {
  let wagmiConfig: Config;

  const init = () => {
    if (feature.isEnabled) {
      const adapter = new WagmiAdapter({
        ssr: true,
        multiInjectedProviderDiscovery: true,
        projectId: feature.isEnabled ? feature.walletConnect.projectId : '',
        networks: [ currentChain ],
        cacheTime: 0,
        chains: [ currentChain ],
        batch,
        transports,
      });
      wagmiConfig = adapter.wagmiConfig;

      createAppKit({
        adapters: [ adapter ],
        networks: [ currentChain ],
        defaultNetwork: currentChain,
        projectId: feature.walletConnect.projectId,
        allowUnsupportedChain: true,
        metadata,
        themeVariables: {
          '--w3m-font-family': `${ BODY_TYPEFACE }, sans-serif`,
          '--w3m-accent': colors.magenta[600],
          '--w3m-border-radius-master': '2px',
          '--w3m-z-index': zIndices.popover,
        },
        featuredWalletIds: [
          '6db5c2cd78ea5a09e820b7543dacc90bf3b1727e5bbaddff544b301de1f74f39', // fastex wallet
          'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', // metamask
          'ecc4036f814562b41a5268adc86270fba1365471402006302e70169465b7ac18',
        ],
        features: {
          onramp: false,
          swaps: false,
          analytics: false,
          socials: [],
          email: false,
        },
      });
    } else {
      wagmiConfig = createConfig({
        ssr: true,
        chains,
        transports,
        batch,
      });
    }
  };

  const getWagmiConfig = () => {
    return wagmiConfig;
  };

  init();

  return {
    getWagmiConfig,
  };
})();

export default WalletInitModule;
